var map = {
	"./auctions-green.svg": 5057,
	"./building-green.svg": 4695,
	"./contactUs-img.jpg": 7270,
	"./frozen-user.png": 2274,
	"./homepage-img.jpg": 9068,
	"./icons/arrow-icon-new.png": 4133,
	"./icons/chevron-down-blue.svg": 5583,
	"./icons/chevron-down.svg": 350,
	"./icons/collateral-homepage-icon.png": 1845,
	"./icons/external-link-icon.svg": 4268,
	"./icons/participant-homepage-icon.png": 5593,
	"./icons/users-homepage-icon.png": 8542,
	"./icons/warning.svg": 2428,
	"./invoices.svg": 7165,
	"./logos/MFE-logo-black.png": 3793,
	"./logos/eex-logo-footer.png": 5371,
	"./logos/eex-logo-homebanner.png": 3265,
	"./logos/nz-govt-logo-footer.png": 1008,
	"./logos/nzx-logo-footer.png": 8805,
	"./logos/nzx-logo-homebanner.png": 5135,
	"./manage-auctions.svg": 9967,
	"./noticeboard-img.png": 5922,
	"./training-img.png": 662,
	"./training/bid-csv-example.png": 3082,
	"./training/bid-in-auction.png": 5478,
	"./training/bid-in-bidding-system.png": 6160,
	"./training/cheatsheet.png": 7115,
	"./training/clearing-price-calculation.png": 1460,
	"./training/cost-containment-reserve-1-tier.png": 803,
	"./training/cost-containment-reserve-2-tier.png": 3150,
	"./training/invite-user.png": 6296,
	"./training/manage-users.png": 5995,
	"./training/participant-details-highlighted-screenshot.png": 4294,
	"./training/roles.png": 9078,
	"./training/training-become-participant-step1.png": 5281,
	"./training/training-become-participant-step3.png": 9763,
	"./training/use-cash-collateral-highlighted-screenshot.png": 4293,
	"./training/verify-nz-passport.png": 2278,
	"./training/verify-other-passport.png": 9584,
	"./users-green.svg": 7497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;